export default {"src":"/_next/static/media/loading.4a275772.svg","height":200,"width":200};